/**
 * ToolbarCommandPaletteTrigger
 *
 * A compact search-input-styled button in the toolbar that opens the command palette.
 */

import { Search } from 'lucide-react';
import { useAnalytics } from '../../../core/analytics/useAnalytics';
import { useCommandPaletteStore } from '../store/commandPaletteStore';
import { useResponsiveToolbar } from '../../../components/ui/responsive-toolbar';
import { useShortcutLabel } from '../../keybindings/hooks/useShortcutLabel';

export function ToolbarCommandPaletteTrigger() {
  const shortcutLabel = useShortcutLabel('global.commandPalette');
  const { track } = useAnalytics();
  const open = useCommandPaletteStore((s) => s.open);
  const { rightCollapseState } = useResponsiveToolbar();
  const isCollapsed = rightCollapseState === 'collapsed';

  return (
    <button
      type="button"
      onClick={() => {
        track('toolbar:command_palette_opened');
        open();
      }}
      className="flex items-center gap-1.5 rounded-md border border-input bg-background px-2 py-1 text-sm text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-[color,background-color,scale] active:scale-[0.96] cursor-pointer relative before:absolute before:inset-x-0 before:-inset-y-1.5 before:content-['']"
      title={`Command Palette${shortcutLabel ? ` (${shortcutLabel})` : ''}`}
      data-toolbar-item
      data-testid="toolbar-command-palette-trigger"
    >
      <Search className="h-3.5 w-3.5 shrink-0" />
      {!isCollapsed && (
        <span className="text-xs text-muted-foreground/70">{shortcutLabel}</span>
      )}
    </button>
  );
}
